export const styles = {
  inputRoot: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '100px',
      height: '44px'
    },
    '& .MuiInputBase-root': {
      background: '#fff',
      borderRadius: '4px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#B0B8CB'
    },
    '& .MuiOutlinedInput-input': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  inputRootSquare: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px'
    },
    '& .MuiInputBase-root': {
      alignItems: 'center'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#393939'
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 12px'
    },
    '& .MuiInputBase-inputAdornedStart': {
      paddingLeft: 0
    }
  },
  filterIconContainer: {
    paddingLeft: 8
  }
};
